$xsmall-min: 767px;

fccd-see-more-times-modal {
  .modal-basic {
    margin-top: var(--spacing-md);
    margin-left: var(--spacing-md);
  }

  .body {
    .doctor-info {
      display: inline-flex;

      hp5-person-image {
        margin-top: 0;
        margin-left: 0;
        margin-bottom: var(--spacing-sm);
        margin-right: var(--spacing-xs);
      }

      hp5-heading {
        padding-top: var(--spacing-xs);
        padding-bottom: 0;
      }

      hp5-semantic {
        padding-top: var(--spacing-xxs);
        padding-bottom: 0;
      }
    }

    .location-and-date {
      margin-bottom: var(--spacing-sm);
    }

    .next-available .time-slots .load-more-times {
      position: relative;
      margin-top: var(--spacing-sm);
      margin-bottom: var(--spacing-sm);

      hp5-button-decorator {
        button {
          padding-top: var(--spacing-sm);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .after-grid {
      margin-top: var(--spacing-sm);
    }
  }

  .modal-buttons {
    display: flex;
    flex-direction: column;
    padding-top: var(--spacing-sm);

    button {
      margin-top: var(--spacing-sm);
      width: 100%;
    }
  }
}
